import React, { useState, useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Divider, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "../../../components/autocomplete/Autocomplete.styles.js";
import "../../../components/autocomplete/Autocomplete.localize.js";
import "react-virtualized-auto-sizer";
import "react-window";
import "@mui/icons-material";
import "@mui/x-tree-view";
import "../../../components/tree-view/TreeViewItemExpandableOption.js";
import "../../../components/autocomplete/AutocompleteInfoMessage.js";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import { isStringNullOrEmpty } from "../../../utils/string.js";
import "moment-timezone";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "fast-deep-equal/es6";
import "@mui/material/CircularProgress";
import "@mui/material/TextField";
import "../../../components/button/Buttons.js";
import "../../../components/button/EditButton.js";
import "../../../components/autocomplete/Autocomplete.js";
import "../../../components/tree-view/TreeViewItemSelectOption.js";
import { AutocompleteButton } from "../../../components/autocomplete/AutocompleteButton.js";
import "../../../components/form/Form.js";
import "../../../components/form/FormControlGroup.js";
import "../../../components/form/FormLabel.js";
import { ToggleSwitch } from "../../../components/form/ToggleSwitch.js";
import { useAgentProfiles } from "../hooks.js";
import { AgentAutocomplete } from "./AgentAutocomplete.js";
import "../../../api/types.js";
import "immer";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../../localization/MessageLocalizer.js";
import "../../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../../localization/sharedResources.js";
import "typesafe-actions";
import { extendedViewCleanDelay } from "../../../redux-folder/view/types.js";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "normalizr";
import "../../../redux-folder/entity/EntityProvider.js";
import "../../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import "react-redux";
import "react-router";
const localized = defineMessages({
  downlineLabel: {
    id: "AgentFilter_downlineLabel",
    defaultMessage: "Include Downline"
  },
  agentLabel: {
    id: "AgentFilter_agentLabel",
    defaultMessage: "Agent"
  },
  cancel: {
    id: "AgentFilter_cancel",
    defaultMessage: "Cancel"
  }
});
const useClasses = makeStyles()((theme) => {
  return {
    autocompleteButtonFullWidth: {
      width: "100%",
      "& .MuiButton-endIcon": {
        marginLeft: "auto"
      }
    },
    agentPlayerReportingFilterReferrerContainer: {
      width: "360px"
    },
    agentPlayerReportingFilterReferrerToggle: {
      paddingTop: 0,
      [theme.breakpoints.down("md")]: {
        margin: theme.spacing(2, 0),
        padding: 0,
        borderBottom: "none"
      }
    },
    agentPlayerReportingFilterReferrer: {
      paddingTop: theme.spacing(1.25),
      minHeight: "170px"
    },
    agentPlayerReportingFilterReferrerList: {
      height: "170px",
      [theme.breakpoints.down("md")]: {
        flexGrow: 1,
        height: "unset",
        "& > div": {
          gap: theme.spacing(1)
        },
        "& .MuiTreeView-root": {
          margin: `${theme.spacing(0, -2)} !important`
        }
      }
    },
    agentPlayerReportingFilterReferrerTree: {
      height: "max-content",
      "& p": {
        marginTop: theme.spacing(2.5)
      },
      [theme.breakpoints.down("md")]: {
        flexGrow: 1,
        height: "unset",
        "& > div": {
          gap: theme.spacing(1)
        }
      }
    },
    agentPlayerReportingFilterDivider: {
      marginBottom: theme.spacing(1.25),
      borderColor: theme.palette.secondary.light
    },
    autocompleteItemsContainer: {
      [theme.breakpoints.down("md")]: {
        height: "300px",
        margin: `${theme.spacing(0, -2)} !important`
      }
    }
  };
});
function AgentFilter({
  defaultPlayerId,
  value,
  onChange,
  withDownstream,
  viewType,
  displayMode = "desktop",
  agentProfileEntity,
  isTreeMode,
  width = "fixed"
}) {
  const { classes } = useClasses();
  const currentAgentUsername = useCurrentAgentUsername({ viewType, agentId: value?.agentId, agentProfileEntity });
  const [isDownstream, setIsDownstream] = useState(value?.isDownstream);
  const [selectedAgentId, setSelectedAgentId] = useState(value?.agentId);
  const isMobile = displayMode === "mobile";
  useEffect(() => {
    setSelectedAgentId(value?.agentId);
  }, [value?.agentId]);
  useEffect(() => {
    setIsDownstream(value?.isDownstream);
  }, [value?.isDownstream]);
  function handleApplyClick() {
    onChange({ agentId: selectedAgentId, isDownstream });
  }
  useEffect(() => {
    if (isMobile) {
      handleApplyClick();
    }
  }, [selectedAgentId, isDownstream]);
  function handleAutocompleteChange(newAgentId) {
    setSelectedAgentId(newAgentId);
  }
  function handleDownstreamChange(value2) {
    setIsDownstream(value2);
  }
  const agentFilterInputs = /* @__PURE__ */ React.createElement(
    AgentFilterInputs,
    {
      withDownstream,
      isDownstream,
      isTreeMode,
      viewType,
      selectedAgentId,
      defaultPlayerId,
      onDownstreamChange: handleDownstreamChange,
      onAutocompleteChange: handleAutocompleteChange,
      agentProfileEntity
    }
  );
  return isMobile ? agentFilterInputs : /* @__PURE__ */ React.createElement(
    AutocompleteButton,
    {
      label: localized.agentLabel,
      selectedText: currentAgentUsername,
      applyActionLabel: sharedLocalization.apply,
      cancelActionLabel: localized.cancel,
      onApply: handleApplyClick,
      className: width === "full" && classes.autocompleteButtonFullWidth
    },
    /* @__PURE__ */ React.createElement("div", { className: classes.agentPlayerReportingFilterReferrerContainer }, agentFilterInputs, /* @__PURE__ */ React.createElement(Divider, { className: classes.agentPlayerReportingFilterDivider }))
  );
}
function AgentFilterInputs({
  withDownstream,
  isDownstream,
  isTreeMode,
  viewType,
  selectedAgentId,
  defaultPlayerId,
  onDownstreamChange,
  onAutocompleteChange,
  agentProfileEntity
}) {
  const { classes, cx } = useClasses();
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, withDownstream && /* @__PURE__ */ React.createElement(
    ToggleSwitch,
    {
      className: classes.agentPlayerReportingFilterReferrerToggle,
      value: isDownstream,
      onChange: onDownstreamChange,
      fieldName: formatMessage(localized.downlineLabel),
      withBorder: true,
      withVerticalPaddings: true
    }
  ), /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(
        isTreeMode ? classes.agentPlayerReportingFilterReferrerTree : classes.agentPlayerReportingFilterReferrerList,
        classes.agentPlayerReportingFilterReferrer
      )
    },
    /* @__PURE__ */ React.createElement(
      AgentAutocomplete,
      {
        viewType,
        value: selectedAgentId,
        onChange: onAutocompleteChange,
        defaultPlayerId,
        mode: isTreeMode ? "tree" : "inline",
        listContainerClassName: classes.autocompleteItemsContainer,
        agentProfileEntity
      }
    )
  ));
}
function useCurrentAgentUsername({
  viewType,
  agentId,
  agentProfileEntity
}) {
  const { items: filterAgentProfile } = useAgentProfiles({
    viewType,
    agentProfileEntity,
    fields: ["uid", "username"],
    defaultFilters: [{ key: "uid", value: agentId }],
    validateFilter: (filter) => !isStringNullOrEmpty(filter?.find((f) => f.key === "uid")?.value),
    cleanDelay: extendedViewCleanDelay
  });
  const selectedAgentUsername = filterAgentProfile?.[0]?.username;
  return selectedAgentUsername;
}
export {
  AgentFilter,
  useCurrentAgentUsername
};
//# sourceMappingURL=AgentFilter.js.map
